// extracted by mini-css-extract-plugin
export default {"main":"Xea-z"};